import React, { useState } from 'react';
import {
  Box,
  Button,
  Input,
  Stack,
  Heading,
  Flex,
  Text,
  Icon,
  InputGroup,
  InputLeftElement,
  useToast,
  FormControl,
  FormLabel,
} from '@chakra-ui/react';
import { Navigate } from 'react-router-dom';
import { FiUser, FiLock } from 'react-icons/fi';

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const LoginForm = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loggedIn, setLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const csrftoken = getCookie('csrftoken');
    try {
      const response = await fetch('/api/v1/auth/login/', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'X-CSRFToken': csrftoken,
        },
        body: JSON.stringify({ username, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data.token);
        onLogin();
        setLoggedIn(true);
      } else {
        toast({
          title: 'Login failed',
          description: 'Invalid credentials',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (e) {
      toast({
        title: 'Login failed',
        description: 'An error occurred.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (loggedIn) {
    return <Navigate to="/" />;
  }

  return (
    <Flex
      minHeight="100vh"
      align="center"
      justify="center"
      bgGradient="linear(to-br, orange.400, orange.700)"
    >
      <Box
        bg="white"
        px={10}
        py={12}
        borderRadius="2xl"
        boxShadow="2xl"
        width="100%"
        maxWidth="400px"
      >
        <Flex justify="center" mb={6}>
          <Box
            w={20}
            h={20}
            borderRadius="full"
            overflow="hidden"
            bg="orange.50"
            p={1}
          >
            <img src="/selwyn-logo.png" alt="Selwyn" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
          </Box>
        </Flex>
        <Heading size="lg" textAlign="center" mb={2} color="gray.700">
          Marketing Brevo
        </Heading>
        <Text textAlign="center" color="gray.500" mb={8}>
          Sign in to your account
        </Text>
        
        <form onSubmit={handleLogin}>
          <Stack spacing={5}>
            <FormControl>
              <FormLabel color="gray.600" fontSize="sm">Username</FormLabel>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <Icon as={FiUser} color="gray.400" />
                </InputLeftElement>
                <Input
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  size="lg"
                  borderRadius="lg"
                  focusBorderColor="orange.500"
                />
              </InputGroup>
            </FormControl>
            
            <FormControl>
              <FormLabel color="gray.600" fontSize="sm">Password</FormLabel>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <Icon as={FiLock} color="gray.400" />
                </InputLeftElement>
                <Input
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  size="lg"
                  borderRadius="lg"
                  focusBorderColor="orange.500"
                />
              </InputGroup>
            </FormControl>
            
            <Button
              type="submit"
              colorScheme="orange"
              size="lg"
              width="full"
              borderRadius="lg"
              isLoading={isLoading}
              loadingText="Signing in..."
              mt={4}
            >
              Sign In
            </Button>
          </Stack>
        </form>
      </Box>
    </Flex>
  );
};

export default LoginForm;
